import React from "react";

const AwardSection = () => {
  return (
    <img
      src="/assets/award-georgia.svg"
      alt="Voted Best of Georgia 2025"
      className="w-100"
    />
  );
};

export default AwardSection;
